import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { DocumentName } from "@components/documents/DocumentName";
import { HistoryDocumentCreateDeleteDetailsRow } from "../utils/historyDocumentDetailsRow";

const RAW_DASH = "-";

interface Props {
    row: { original: HistoryDocumentCreateDeleteDetailsRow };
    side: "previous" | "modified";
}

const HistoryDocumentCreateDeleteValueCell = memo(({ row, side }: Props) => {
    const text =
        side === "previous" ? row.original.previous : row.original.modified;

    if (text === RAW_DASH) {
        return (
            <ViewTableCell>
                <EmptyValue />
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell>
            <DocumentName
                fileName={text}
                documentId={row.original.resourceId}
            />
        </ViewTableCell>
    );
});

HistoryDocumentCreateDeleteValueCell.displayName =
    "HistoryDocumentCreateDeleteValueCell";

export const HistoryDocumentCreateDeletePreviousCell = memo(
    (props: { row: { original: HistoryDocumentCreateDeleteDetailsRow } }) => (
        <HistoryDocumentCreateDeleteValueCell {...props} side="previous" />
    ),
);
HistoryDocumentCreateDeletePreviousCell.displayName =
    "HistoryDocumentCreateDeletePreviousCell";

export const HistoryDocumentCreateDeleteModifiedCell = memo(
    (props: { row: { original: HistoryDocumentCreateDeleteDetailsRow } }) => (
        <HistoryDocumentCreateDeleteValueCell {...props} side="modified" />
    ),
);
HistoryDocumentCreateDeleteModifiedCell.displayName =
    "HistoryDocumentCreateDeleteModifiedCell";
